import format from 'date-fns/format';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import isToday from 'date-fns/isToday';

export function formatCreatedOnDate(createdOn: Date) {
  if (isToday(createdOn)) {
    return `Created ${formatDistanceToNowStrict(createdOn)} ago`;
  } else {
    return `Created on ${format(createdOn, 'M/d/yyyy')}`;
  }
}
